import { render, staticRenderFns } from "./UpgradeFileModal.vue?vue&type=template&id=ba515022&"
import script from "./UpgradeFileModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports